import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import TabbedNavigation from "@/components/TabbedNavigation.jsx";

const COMPLIANCE_BASE = '/admin/compliance';

const COMPLIANCE_TABS = [
  { id: 'tax-rules', label: 'Tax Rules' },
  { id: 'state-restrictions', label: 'State Restrictions' },
  { id: 'purchase-attestations', label: 'Purchase Attestations' },
  { id: 'product-tags', label: 'Product Tags' },
  { id: 'product-georestriction', label: 'Product Georestriction' },
  { id: 'compliance-check', label: 'Compliance check' },
];

const ComplianceLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab =
    COMPLIANCE_TABS.find((tab) =>
      location.pathname.startsWith(`${COMPLIANCE_BASE}/${tab.id}`)
    )?.id || 'tax-rules';

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Top-level page tabs */}
      <div className="mb-6">
        <TabbedNavigation
          tabs={COMPLIANCE_TABS}
          activeTab={activeTab}
          onTabChange={(tab) => navigate(`${COMPLIANCE_BASE}/${tab}`)}
          variant="underline"
          size="lg"
          className="flex-wrap"
        />
      </div>

      <Outlet />
    </div>
  );
};

export default ComplianceLayout;
